import { Status } from "../../admin";

export enum CategoryType {
  MUSCLE = "MUSCLE",
  EQUIPMENT = "EQUIPMENT",
  SESSION = "SESSION",
}

export type IStatus = Status;
